import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  public symbol: string = 'VND';

  transform(value: number | undefined, position: 'before_price' | 'after_price' | string = 'after_price'): string | number {
    if(!value) {
      value = 0;
    };
    value = Number(value);

    const currenyFormat = Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: "VND"
    });
    return `${currenyFormat.format(value)}`;
  }
}
